import InfoLayout from "./InfoLayout";

function License() {
    return (
        <InfoLayout title="Licenční podmínky">
            <div>
            <h2>1. Vlastnictví</h2>
                <p>
                    Aplikace <strong>Tabata časovač</strong> je výhradně vlastnictvím
                    <a href="https://www.tabataworkout.online" target="_blank" rel="noopener noreferrer"> www.tabataworkout.online</a>. 
                    Veškerý obsah aplikace, včetně kódu, designu, textů a multimediálních prvků, patří provozovateli a je chráněn autorskými právy.
                </p>

                <h2>2. Používání aplikace</h2>
                <p>
                    Aplikace je poskytována zdarma a je určena k použití prostřednictvím webového prohlížeče. Neposkytujeme instalační soubory – aplikaci spustíte přímo online. 
                    Uživatel má nevýhradní, nepřenosnou licenci k používání aplikace pro osobní a nekomerční účely. 
                </p>
                <p>
                    Freemium verze může obsahovat reklamy. Použití aplikace k nelegálním nebo škodlivým účelům je zakázáno.
                    Aplikaci můžete sdílet s ostatními prostřednictvím odkazu, doporučovat ji dalším uživatelům nebo ji propagovat.
                </p>

                <h2>3. Omezení</h2>
                <ul>
                    <li>Nesmíte aplikaci kopírovat, distribuovat, prodávat ani jinak komerčně využívat bez písemného souhlasu provozovatele.</li>
                    <li>Nesmíte se pokoušet zpětně dekompilovat, upravovat nebo odhalovat zdrojový kód aplikace.</li>
                    <li>Nesmíte odstraňovat nebo měnit obsah ochranných prvků, log nebo autorských informací.</li>
                </ul>

                <h2>4. Odpovědnost</h2>
                <p>
                    Aplikace je poskytována „tak jak je“ a provozovatel nenese odpovědnost za jakékoliv škody, ztrátu dat nebo jiné problémy vzniklé používáním aplikace. 
                    Používáním aplikace uživatel potvrzuje, že chápe a přijímá tato rizika.
                </p>

                <h2>5. Aktualizace a změny</h2>
                <p>
                    Provozovatel si vyhrazuje právo aplikaci kdykoliv aktualizovat, měnit její funkce nebo ukončit dostupnost aplikace bez předchozího upozornění. 
                    Doporučujeme sledovat aktuální verzi licenčních podmínek.
                </p>

                <h2>6. Kontakt</h2>
                <p>
                    Máte-li jakékoliv otázky ohledně licenčních podmínek, můžete nás kontaktovat na: 
                    <strong>admin@tabataworkout.online</strong>. 
                    Rádi zodpovíme vaše dotazy nebo poskytneme potřebnou podporu.
                </p>

                <p>
                    Používáním této aplikace potvrzujete, že jste si přečetli a souhlasíte s výše uvedenými licenčními podmínkami.
                </p>
      </div>
        </InfoLayout>
    );
}

export default License;
